export default __webpack_public_path__ + "static/11013-b56a2a1dd82099d472711acaa0a03ae9.jpg";